import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/global";
import "./styles.scss";

function getGreeting() {
  const hour = new Date().getHours();
  if (hour < 12) return "Buenos días";
  if (hour < 18) return "Buenas tardes";
  return "Buenas noches";
}

export default function BannerFront() {
  const { user } = useContext(AppContext);
  const greeting = getGreeting();
  const userName = user?.given_name || "Usuario";

 
  const backgroundColor = "linear-gradient(135deg, #DA291C 0%, #DA291C 18%, #C72A1C 32%, #B51E1E 50%, #4A5FC1 75%, #0033A0 100%)";
//   const backgroundImage = "";


  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString("es-CO", { hour: "2-digit", minute: "2-digit", hour12: true })
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(
        new Date().toLocaleTimeString("es-CO", { hour: "2-digit", minute: "2-digit", hour12: true })
      );
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className="banner-dynamic"
      style={{
        background: backgroundColor,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div className="banner-dynamic-content">
        <h2 className="banner-dynamic-greeting">
          {greeting}, {userName}!
        </h2>
        <p className="banner-dynamic-message">
        ¡Bienvenido a Portal Yamaha Colombia! Tu punto de encuentro con todo lo que somos.
        </p>
        <div className="banner-dynamic-time">
          {(() => {
            const date = new Date();
            const options = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
            let formatted = date.toLocaleDateString("es-CO", options);


            formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);

            const lastDeIndex = formatted.lastIndexOf(" de ");
            if (lastDeIndex !== -1) {
              formatted = formatted.slice(0, lastDeIndex) + " " + formatted.slice(lastDeIndex + 4);
            }

            return formatted;
          })()}
        </div>
      </div>
      <div className="banner-dynamic-clock">
        {currentTime}
      </div>
    </div>
  );
}